var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgImgRegisterSuccess = function SvgImgRegisterSuccess(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 250,
    height: 160,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "a",
    cx: 80.028,
    cy: 80,
    r: 80
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M40.421 10.105c6.201 0 11.228 5.027 11.228 11.228v12.351c0 .62-.503 1.123-1.123 1.123h-20.21c-.62 0-1.123-.503-1.123-1.123v-12.35c0-6.202 5.027-11.229 11.228-11.229z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#B5D100",
    strokeDasharray: "0 5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6,
    d: "M10.597 151.28c37.91-20.468 35.556-34.594 27.918-40.252-7.637-5.658-20.837 10.895 1.414 18.223 22.252 7.328 112.683-51.763 147.994-67.894 35.312-16.131 73.28.622 36.226 24.856"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(46)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#B5D100",
    fillOpacity: 0.1,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#B5D100",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6,
    mask: "url(#b)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133 62h6m-3-3v6"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#B5D100",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6,
    mask: "url(#b)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34 37h4m-2-2v4"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#B5D100",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6,
    mask: "url(#b)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94 21.5h3M95.5 20v3"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(54 30)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#B5D100",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6,
    d: "M21.333 34.807h8.983v28.07c0 .62-.503 1.123-1.123 1.123h-6.737c-.62 0-1.123-.503-1.123-1.123v-28.07h0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDBDBD",
    fillOpacity: 0.3,
    stroke: "#B5D100",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6,
    d: "M21.895 60.07h7.86"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#B5D100",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6,
    d: "M40.421 34.807H1.123c-.62 0-1.123-.503-1.123-1.123v-12.35c0-6.202 5.027-11.229 11.228-11.229h29.193"
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#B5D100",
    fillOpacity: 0.2,
    stroke: "#B5D100",
    strokeWidth: 1.6,
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 24.14,
    cy: 15.158,
    r: 1.684,
    fill: "#FFF",
    stroke: "#B5D100",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDBDBD",
    fillOpacity: 0.3,
    stroke: "#B5D100",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6,
    d: "M24.14 12.912V5.614"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#B5D100",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6,
    d: "M15.719 0h10.105v5.614H15.719z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20.211,
    height: 4.491,
    x: 4.491,
    y: 26.947,
    fill: "#B5D100",
    fillOpacity: 0.2,
    rx: 2.246
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#B5D100",
    strokeOpacity: 0.1,
    strokeWidth: 1.6,
    d: "M46 59.8c-11.575 0-21.34 8.714-22.965 20.31l-.096.69H17.5C8.277 80.8.8 88.277.8 97.5c0 9.223 7.477 16.7 16.7 16.7H89c6.186 0 11.2-5.014 11.2-11.2 0-6.186-5.014-11.2-11.2-11.2h-4.848l.038-.835c.007-.155.01-.31.01-.465 0-5.366-4.128-9.7-9.2-9.7a8.79 8.79 0 0 0-4.66 1.335l-1.114.692-.106-1.307C68.13 69.284 58.088 59.8 46 59.8z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B5D100",
    fillOpacity: 0.15,
    d: "M147 98c9.37 0 17.234 6.443 19.405 15.14A9 9 0 0 1 177 122v.045c5.606.505 10 5.217 10 10.955 0 6.075-4.925 11-11 11h-73.5c-6.351 0-11.5-5.149-11.5-11.5s5.149-11.5 11.5-11.5h6.51c.25-6.12 5.075-11 10.99-11 2.942 0 5.614 1.207 7.587 3.174C129.746 104.459 137.62 98 147 98z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#B5D100",
    strokeOpacity: 0.1,
    strokeWidth: 1.6,
    d: "M25 95.8c-8.947 0-16.2 7.253-16.2 16.2v.8H-.5c-5.91 0-10.7 4.79-10.7 10.7 0 5.91 4.79 10.7 10.7 10.7h49c4.805 0 8.7-3.895 8.7-8.7s-3.895-8.7-8.7-8.7h-7.99l.239-.987c.299-1.238.451-2.515.451-3.813 0-8.947-7.253-16.2-16.2-16.2z",
    mask: "url(#b)",
    transform: "matrix(-1 0 0 1 46 0)"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#B5D100",
    strokeWidth: 1.6,
    transform: "rotate(-15 423.738 -589.744)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 28,
    x: 0.815,
    y: 0.786,
    fill: "#FFF",
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m3.729 3.534 18.957 12.85a2.998 2.998 0 0 0 3.384-.011L44.729 3.534h0M20.034 15.049 4.471 25.663m24.299-11.03 14.994 10.855L28.77 14.633z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgImgRegisterSuccess);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/img-register-success.fb4759ca89d17e84cc289cb744d789ef.svg";